<div class="stock-page">
  <div class="chart-wrapper" [class.panel-open]="sidePanelOpen">

    <!-- ═══════════════════════════════════════════════════
         LEFT PANEL — Controls (resizable)
         ═══════════════════════════════════════════════════ -->
    <div class="left-panel" [style.width.px]="leftPanelWidth">
    <div class="info-box">

      <!-- Header: symbol + actions -->
      <div class="info-header">
        <div class="symbol-label">
          <span class="symbol-name">{{ getSelectedCompanyName() || '—' }}</span>
        </div>
        <div class="header-actions">
          <button class="icon-btn" title="Guardar como favorito" (click)="showSaveFav = !showSaveFav; favoriteName = ''">
            <i class="ri-star-line" [class.ri-star-fill]="showSaveFav"></i>
          </button>
          <button class="icon-btn" [class.copied]="copiedShare" title="Compartir condición" (click)="shareCondition()">
            <i [class]="copiedShare ? 'ri-check-line' : 'ri-share-forward-line'"></i>
          </button>
        </div>
      </div>

      <!-- Save favorite inline form -->
      <div class="save-fav-row" *ngIf="showSaveFav">
        <input class="form-control form-control-sm" placeholder="Nombre del favorito…"
               [(ngModel)]="favoriteName" (keyup.enter)="saveFavorite()" maxlength="40" />
        <button class="btn btn-sm btn-warning" (click)="saveFavorite()" [disabled]="!favoriteName.trim()">
          <i class="ri-save-line"></i>
        </button>
        <button class="btn btn-sm btn-outline-secondary" (click)="showSaveFav = false">
          <i class="ri-close-line"></i>
        </button>
      </div>

      <!-- Market + Asset grid -->
      <div class="market-asset-grid mb-1">
        <div>
          <label class="form-label">Mercado</label>
          <select class="form-select form-select-sm" [(ngModel)]="selectedMarketId" (change)="onMarketChange($event)">
            <option *ngFor="let m of markets" [ngValue]="m.idmercado">{{ m.iso || m.nombre || m.idmercado }} ({{m.activos}})</option>
          </select>
        </div>
        <div>
          <label class="form-label">Activo</label>
          <ng-select [items]="companies"
                     bindLabel="iso"
                     bindValue="idNectum"
                     [(ngModel)]="selectedCompanyId"
                     (change)="onCompanyChange($event)"
                     placeholder="Activo">
          </ng-select>
        </div>
         <!-- Periodo -->
        <div class="d-flex gap-2 align-items-center mb-1">
          <select class="form-select form-select-sm flex-fill" style="max-width:5rem;"
                  [(ngModel)]="adminPeriodo" (change)="onAdminPeriodoChange()">
            <option *ngFor="let p of periodos" [ngValue]="p.value">{{ p.label }}</option>
          </select>
        </div>
        
      </div>
<div class="date-row mb-1">
        <div>
          <label class="form-label">Desde</label>
          <input type="date" class="form-control form-control-sm"
                 [(ngModel)]="fecha" (ngModelChange)="onFechaChange($event)" />
        </div>
        <div>
          <label class="form-label">Hasta</label>
          <input type="date" class="form-control form-control-sm"
                 [(ngModel)]="fechaFin" (ngModelChange)="onFechaFinChange($event)" />
        </div>
      </div>
      <!-- Price display -->
      <div class="price-row" *ngIf="currentPrice">
        <span class="price-main">{{ currentPrice | number:'1.2-2' }}</span>
        <span class="price-change" [class.positive]="priceChange >= 0" [class.negative]="priceChange < 0">
          {{ priceChange >= 0 ? '+' : '' }}{{ priceChange | number:'1.2-2' }}
          ({{ priceChangePercent >= 0 ? '+' : '' }}{{ priceChangePercent | number:'1.2-2' }}%)
        </span>
      </div>

      <hr class="divider" />

      <!-- Conditions menu button + DSL input -->
      <app-cdk-select [menuDefinitivo]="menuDefinitivo" (buttonClick)="handleButtonClick($event)"></app-cdk-select>
      <label class="form-label" style="font-size:0.75rem; margin-top:0.25rem;">Condición:</label>
      <div class="d-flex align-items-center gap-1 mb-1">
        <input type="text" class="form-control form-control-sm flex-fill"
               [(ngModel)]="currentCondicionInput"
               placeholder="ej: #price:_close > 100" />
        <button class="btn btn-sm p-0 px-1" (click)="openChatIaCondicion()" title="Asistente IA">
          <i class="ri-robot-line"></i>
        </button>
        <button class="btn btn-sm p-0 px-1" (click)="saveCurrentCondicion()" title="Agregar condición"
                [disabled]="!currentCondicionInput.trim()">
          <i class="ri-save-line"></i>
        </button>
      </div>

      <!-- Conditions list -->
      <div *ngIf="condicionesEntradaList.length > 0" class="mb-1">
        <div *ngFor="let c of condicionesEntradaList; let i = index"
             class="d-flex align-items-center gap-1 mb-1">
          <span class="flex-fill text-truncate" style="font-size:0.72rem;">{{ c }}</span>
          <button class="btn btn-sm p-0 px-1" (click)="removeDslCondicion(i)" title="Eliminar">
            <i class="ri-close-line"></i>
          </button>
        </div>
      </div>
      <!-- Date range -->

      <!-- Trade stats card (appears after running) -->
      <div class="stats-card" *ngIf="tradeStats">
        <div class="stats-title">Resultados del backtesting</div>
        <div class="stats-grid">
          <div class="stat-item">
            <span class="stat-val">{{ tradeStats.total }}</span>
            <span class="stat-lbl">Operaciones</span>
          </div>
          <div class="stat-item">
            <span class="stat-val" [class.positive]="tradeStats.winRate >= 50" [class.negative]="tradeStats.winRate < 50">
              {{ tradeStats.winRate | number:'1.0-0' }}%
            </span>
            <span class="stat-lbl">% Acierto</span>
          </div>
          <div class="stat-item">
            <span class="stat-val" [class.positive]="tradeStats.wins > tradeStats.losses" [class.negative]="tradeStats.wins <= tradeStats.losses">
              {{ tradeStats.wins }}W / {{ tradeStats.losses }}L
            </span>
            <span class="stat-lbl">Ganadoras</span>
          </div>
          <div class="stat-item">
            <span class="stat-val" [class.positive]="tradeStats.totalPnl >= 0" [class.negative]="tradeStats.totalPnl < 0">
              {{ tradeStats.totalPnl >= 0 ? '+' : '' }}{{ tradeStats.totalPnl | number:'1.1-1' }}%
            </span>
            <span class="stat-lbl">P&amp;L Total</span>
          </div>
        </div>
      </div>

      <!-- Favorites section -->
      <div class="favorites-section" *ngIf="favorites.length > 0">
        <div class="fav-header" (click)="showFavorites = !showFavorites">
          <span><i class="ri-star-fill me-1" style="color:#f6c343"></i>Favoritos ({{ favorites.length }})</span>
          <i [class]="showFavorites ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'"></i>
        </div>
        <div class="fav-list" *ngIf="showFavorites">
          <div *ngFor="let fav of favorites; let i = index" class="fav-item" (click)="loadFavorite(fav)">
            <div class="fav-info">
              <span class="fav-name">{{ fav.name }}</span>
              <span class="fav-meta"><a *ngIf="fav.idmercado; else symbolSinMercado" class="activo-link" [href]="urlMercadoFavorito(fav)" target="_blank" (click)="$event.stopPropagation()">{{ fav.symbol }} <mat-icon>open_in_new</mat-icon></a><ng-template #symbolSinMercado>{{ fav.symbol }}</ng-template> · {{ fav.dsl || 'Sin condición' }}</span>
            </div>
            <button class="fav-del" (click)="deleteFavorite(i); $event.stopPropagation()" title="Eliminar">
              <i class="ri-delete-bin-line"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Admin: selector de condiciones IA -->
      <div class="admin-conditions-section" *ngIf="isAdmin">
        <hr class="divider" />
        

        

        <!-- Indicador inline mientras procesa -->
        <div class="d-flex align-items-center gap-1 mb-1" *ngIf="isAdminRunning" style="font-size:0.72rem; color:#f6c343;">
          <span class="spinner-border spinner-border-sm" style="width:0.65rem;height:0.65rem;border-width:2px;"></span>
          Calculando…
        </div>

        <div class="d-flex gap-1 align-items-center">
          <button class="btn btn-sm btn-outline-secondary flex-fill"
                  (click)="prevCondicion()"
                  [disabled]="isAdminRunning || condicionesAdmin.length === 0 || selectedCondicionIndex <= 0">
            <i class="ri-arrow-left-s-line"></i> Ant.
          </button>
          <span style="font-size:0.7rem; min-width:2.5rem; text-align:center;">
            {{ selectedCondicionIndex >= 0 ? (selectedCondicionIndex + 1) + '/' + condicionesAdmin.length : '—' }}
          </span>
          <button class="btn btn-sm btn-outline-secondary flex-fill"
                  (click)="nextCondicion()"
                  [disabled]="isAdminRunning || condicionesAdmin.length === 0 || selectedCondicionIndex >= condicionesAdmin.length - 1">
            Sig. <i class="ri-arrow-right-s-line"></i>
          </button>
        </div>

        <!-- Configuración del análisis -->
        <div class="analysis-config mb-2" style="font-size:0.76rem;">
          <!-- Tipo de estrategia -->
          <div class="mb-1 d-flex align-items-center justify-content-between">
            <label class="mb-0">Tipo de estrategia</label>
            <mat-button-toggle-group class="st-toggle-group" [value]="analysisBajista ? 'bajista' : 'alcista'"
              (change)="onAnalysisTipoEstrategiaChange($event)">
              <mat-button-toggle value="alcista">Alcista</mat-button-toggle>
              <mat-button-toggle value="bajista">Bajista</mat-button-toggle>
            </mat-button-toggle-group>
          </div>
          <!-- StopLoss -->
          <div class="d-flex align-items-center gap-1 mb-1">
            <mat-slide-toggle [(ngModel)]="analysisStopLossActivo">Stop Loss %</mat-slide-toggle>
            <input type="number" class="form-control form-control-sm" style="width:4.5rem"
                   [(ngModel)]="analysisStopLoss" [disabled]="!analysisStopLossActivo" min="0">
            <mat-slide-toggle class="ms-1" [(ngModel)]="analysisStopLossDinamico"
                              [disabled]="!analysisStopLossActivo">Din.</mat-slide-toggle>
          </div>
          <!-- Profit -->
          <div class="d-flex align-items-center gap-1 mb-1">
            <mat-slide-toggle [(ngModel)]="analysisProFitActivo">Profit %</mat-slide-toggle>
            <input type="number" class="form-control form-control-sm" style="width:4.5rem"
                   [(ngModel)]="analysisProfit" [disabled]="!analysisProFitActivo" min="0">
          </div>
          <!-- Días salida -->
          <div class="d-flex align-items-center gap-1 mb-1">
            <mat-slide-toggle [(ngModel)]="analysisDiasSalidaActivo">Días salida</mat-slide-toggle>
            <input type="number" class="form-control form-control-sm" style="width:4.5rem"
                   [(ngModel)]="analysisDiasSalida" [disabled]="!analysisDiasSalidaActivo" min="0">
          </div>
          <!-- Toggles secundarios -->
          <div class="d-flex gap-2 flex-wrap mb-1">
            <mat-slide-toggle [(ngModel)]="analysisSalidaFinDia">Fin día</mat-slide-toggle>
            <mat-slide-toggle [(ngModel)]="analysisRepeticionEntradas">Rep. entradas</mat-slide-toggle>
          </div>
        </div>

        <!-- Execute button -->
        <div class="d-grid mb-2">
          <button class="btn btn-primary btn-run" (click)="executeCastConditionsFromUI()" [disabled]="isRunning">
            <span *ngIf="!isRunning"><i class="ri-play-fill me-1"></i>Analizar</span>
            <span *ngIf="isRunning">
              <span class="spinner-border spinner-border-sm me-2"></span>Calculando…
            </span>
          </button>
        </div>

      </div>

    </div>
    </div><!-- /left-panel -->

    <!-- RESIZE HANDLE -->
    <div class="resize-handle" (mousedown)="startResize($event)"></div>

    <!-- Chart Area: toolbar + chart -->
    <div class="chart-area">
      <div class="chart-toolbar">
        <!-- Range -->
        <div class="tb-group">
          <button class="tb-btn" (click)="setRange('1M')">1M</button>
          <button class="tb-btn" (click)="setRange('3M')">3M</button>
          <button class="tb-btn" (click)="setRange('6M')">6M</button>
          <button class="tb-btn" (click)="setRange('1Y')">1A</button>
          <button class="tb-btn" (click)="setRange('5Y')">5A</button>
          <button class="tb-btn" (click)="setRange('all')">Todo</button>
        </div>
        <div class="tb-sep"></div>
        <!-- Chart type -->
        <div class="tb-group">
          <button class="tb-btn" [class.active]="chartType==='candlestick'" (click)="setChartType('candlestick')" title="Velas">&#x1F56F;</button>
          <button class="tb-btn" [class.active]="chartType==='bar'" (click)="setChartType('bar')" title="Barras">&#x2261;</button>
          <button class="tb-btn" [class.active]="chartType==='line'" (click)="setChartType('line')" title="Línea">&#x223F;</button>
          <button class="tb-btn" [class.active]="chartType==='area'" (click)="setChartType('area')" title="Área">&#x25B3;</button>
        </div>
      </div>
      <!-- Toolbar de dibujo compartida (estilo TradingView) + chart -->
      <div class="chart-body">
        <app-drawing-toolbar class="drawing-toolbar-host" [controller]="drawingCtl"></app-drawing-toolbar>
        <div class="chart-stack">
          <div #chartContainer class="chart-container"></div>
          <app-drawing-floating-toolbar [controller]="drawingCtl"></app-drawing-floating-toolbar>
          <app-drawing-object-tree [controller]="drawingCtl"></app-drawing-object-tree>
        </div>
      </div>

      <!-- Overlay: cast_conditions procesando -->
      <div class="chart-processing-overlay" *ngIf="isAdminRunning">
        <span class="overlay-text">Calculando indicadores…</span>
        <div class="overlay-bar"></div>
      </div>

      <!-- Leyenda de condiciones seleccionadas (bottom-left del chart-area) -->
      <div class="cond-legend" *ngIf="isAdmin && selectedCondicionesList.length > 0">
        <div class="cond-legend-title">
          <i class="ri-filter-3-line"></i> Condiciones activas
        </div>
        <div class="cond-legend-items">
          <div *ngFor="let c of selectedCondicionesList" class="cond-legend-item">
            <span class="cond-legend-dsl" [title]="c.indicador">{{ c.indicador }}</span>
            <button class="cond-legend-remove" (click)="removeCondicionFromList(c)" title="Eliminar">
              <i class="ri-close-line"></i>
            </button>
          </div>
        </div>
      </div>

    </div>
  </div>

  <!-- Side Panel Buttons Column (Right) -->
  <div class="side-buttons-column" [class.panel-open]="sidePanelOpen">
    <button class="side-btn"
            [class.active]="activePanelSection === 'indicators'"
            (click)="toggleSidePanel('indicators')"
            title="Indicadores">
      <i class="ri-line-chart-line"></i>
    </button>
    <button class="side-btn"
            [class.active]="activePanelSection === 'alerts'"
            (click)="toggleSidePanel('alerts')"
            title="Alertas">
      <i class="ri-bell-line"></i>
    </button>
    <button class="side-btn"
            [class.active]="activePanelSection === 'settings'"
            (click)="toggleSidePanel('settings')"
            title="Configuración">
      <i class="ri-settings-3-line"></i>
    </button>
  </div>

  <!-- Side Panel Content (Right) -->
  <div class="side-panel" [class.open]="sidePanelOpen">
    <div class="side-panel-header">
      <h6 class="mb-0">
        <span *ngIf="activePanelSection === 'indicators'">Indicadores</span>
        <span *ngIf="activePanelSection === 'alerts'">Alertas</span>
        <span *ngIf="activePanelSection === 'settings'">Configuración</span>
      </h6>
      <button class="btn-close" (click)="closeSidePanel()"></button>
    </div>
    <div class="side-panel-body">

      <!-- ── INDICATORS ──────────────────────────────── -->
      <div *ngIf="activePanelSection === 'indicators'">
        <p class="panel-hint" *ngIf="!historicalData.length"><i class="ri-information-line me-1"></i>Carga primero un activo.</p>
        <p class="panel-hint-label" *ngIf="historicalData.length">Gráfico principal</p>
        <div class="indicator-list">
          <ng-container *ngFor="let ind of indicatorPresets">
            <div class="indicator-item" *ngIf="ind.pane === 'main'">
              <span class="ind-dot" [style.background]="ind.color"></span>
              <span class="ind-label">{{ ind.label }}</span>
              <div class="form-check form-switch mb-0 ms-auto">
                <input class="form-check-input" type="checkbox" [id]="'ind_' + ind.key"
                       [checked]="activeIndicators[ind.key]" (change)="toggleIndicator(ind)" />
              </div>
            </div>
          </ng-container>
        </div>
        <p class="panel-hint-label mt-3">Subpanel</p>
        <div class="indicator-list">
          <ng-container *ngFor="let ind of indicatorPresets">
            <div class="indicator-item" *ngIf="ind.pane === 'sub'">
              <span class="ind-dot" [style.background]="ind.color"></span>
              <span class="ind-label">{{ ind.label }}</span>
              <div class="form-check form-switch mb-0 ms-auto">
                <input class="form-check-input" type="checkbox" [id]="'ind_' + ind.key"
                       [checked]="activeIndicators[ind.key]" (change)="toggleIndicator(ind)" />
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <!-- ── ALERTS ──────────────────────────────────── -->
      <div *ngIf="activePanelSection === 'alerts'">
        <p class="panel-hint">Configura alertas de precio para <strong>{{ getSelectedCompanyName() || 'un activo' }}</strong>.</p>
        <div class="alert-form">
          <label class="form-label">Condición</label>
          <div class="d-flex gap-2 mb-2">
            <select class="form-select form-select-sm" [(ngModel)]="alertDirection" style="width:110px;flex-shrink:0">
              <option value="above">Precio ≥</option>
              <option value="below">Precio ≤</option>
            </select>
            <input type="number" class="form-control form-control-sm"
                   [(ngModel)]="alertPrice" placeholder="Precio" />
          </div>
          <button class="btn btn-sm btn-warning w-100" (click)="addAlert()" [disabled]="!alertPrice">
            <i class="ri-bell-add-line me-1"></i>Crear alerta
          </button>
        </div>
        <div class="alerts-list mt-3" *ngIf="alertsList.length">
          <p class="panel-hint">Alertas guardadas ({{ alertsList.length }}):</p>
          <div class="alert-item" *ngFor="let a of alertsList; let i = index">
            <div class="alert-info">
              <span class="alert-sym">{{ a.symbol }}</span>
              <span class="alert-cond">{{ a.direction === 'above' ? '≥' : '≤' }} {{ a.price | number:'1.2-2' }}</span>
              <span class="alert-date">{{ a.created }}</span>
            </div>
            <button class="fav-del" (click)="removeAlert(i)" title="Eliminar">
              <i class="ri-close-line"></i>
            </button>
          </div>
        </div>
        <p class="panel-hint mt-2" *ngIf="!alertsList.length">No hay alertas configuradas.</p>
      </div>

      <!-- ── SETTINGS ────────────────────────────────── -->
      <div *ngIf="activePanelSection === 'settings'">
        <p class="panel-hint">Apariencia y parámetros del modelo.</p>

        <div class="settings-group">
          <p class="settings-group-title">Gráfico</p>
          <div class="setting-item">
            <label class="setting-label" for="gridToggle">Cuadrícula</label>
            <div class="form-check form-switch mb-0">
              <input class="form-check-input" type="checkbox" id="gridToggle"
                     [(ngModel)]="showGrid" (change)="applyGridSetting()" />
            </div>
          </div>
          <div class="setting-item">
            <label class="setting-label" for="logToggle">Escala logarítmica</label>
            <div class="form-check form-switch mb-0">
              <input class="form-check-input" type="checkbox" id="logToggle"
                     [(ngModel)]="logScale" (change)="applyLogScale()" />
            </div>
          </div>
        </div>

        <hr class="divider" />

        <div class="settings-group">
          <p class="settings-group-title">Modelo de backtesting</p>
          <div class="setting-item">
            <label class="setting-label">Stop Loss (%)</label>
            <input type="number" class="form-control form-control-sm setting-input"
                   [(ngModel)]="condicionJson.stopLoss" min="1" max="100" />
          </div>
          <div class="setting-item">
            <label class="setting-label" for="dynSl">Stop Loss dinámico</label>
            <div class="form-check form-switch mb-0">
              <input class="form-check-input" type="checkbox" id="dynSl"
                     [(ngModel)]="condicionJson.stopLossDinamicActivo" />
            </div>
          </div>
          <div class="setting-item">
            <label class="setting-label">Take Profit (%)</label>
            <input type="number" class="form-control form-control-sm setting-input"
                   [(ngModel)]="condicionJson.profit" min="1" max="200" />
          </div>
          <div class="setting-item">
            <label class="setting-label">Período (meses)</label>
            <input type="number" class="form-control form-control-sm setting-input"
                   [(ngModel)]="condicionJson.periodo" min="1" />
          </div>
          <div class="setting-item">
            <label class="setting-label" for="bajistaTog">Tendencia bajista</label>
            <div class="form-check form-switch mb-0">
              <input class="form-check-input" type="checkbox" id="bajistaTog"
                     [(ngModel)]="condicionJson.bajista" />
            </div>
          </div>
          <div class="setting-item">
            <label class="setting-label" for="noCondTog">Sin condiciones (siempre entra)</label>
            <div class="form-check form-switch mb-0">
              <input class="form-check-input" type="checkbox" id="noCondTog"
                     [(ngModel)]="condicionJson.nocondiciones" />
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
